import axios, { AxiosError } from 'axios';

export  function  setupAPIclient() {
    const api = 
    axios.create({
        baseURL: 'https://alexios.com.br:9597/auth', // Altere para o domínio
        timeout: 10000,

    }) 
    api.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            console.error("Erro na requisição:", error.message);
            return Promise.reject(error);
        }
    );
    return api
}



